import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable()
export class SidenavService{
    opened: Subject<boolean>;
    constructor(){
        this.opened = new Subject();
    }
}